export const fmtNumber = (v, decimals = 0) => {
  if (v === null || v === undefined || isNaN(Number(v))) return "—";
  return Number(v).toLocaleString("pt-BR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const fmtMoney = (v) => {
  if (v === null || v === undefined || isNaN(Number(v))) return "—";
  return Number(v).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

export const fmtKwh = (v) => (v === null || v === undefined ? "—" : `${fmtNumber(v, 0)} kWh`);

export const monthLabel = (yyyyMm) => {
  if (!yyyyMm) return "—";
  const parts = yyyyMm.includes("/") ? yyyyMm.split("/") : yyyyMm.split("-");
  const names = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
  let year, month;
  if (yyyyMm.includes("/")) {
    // MM/YYYY
    month = parseInt(parts[0], 10);
    year = parseInt(parts[1], 10);
  } else {
    // YYYY-MM
    year = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10);
  }
  if (!month || !year) return yyyyMm;
  return `${names[month - 1]}/${String(year).slice(-2)}`;
};
